/**
 * 
 * @author Teresa Ocampo Román
 * @company Erillam Healthcare
 * @version 1.0
 * 
 */

 import axios from 'axios';
 import ServicePath from "@/core/ServicePath"
 import { MainRequest } from "@/core/request";
 
 export default class RoleRequest extends MainRequest {
 
 
     static addRole(data) {
         return this.postSEC(ServicePath.ROLE_ADD, data);
     }
 
     static listAllRoles() {
         return this.getSEC(ServicePath.ROLE_ALL);
     }
 
     static updateRole(data) {
         return this.postSEC(ServicePath.ROLE_UPDATE, data);
     }
 
     static deleteRole(data) {
         return this.postSEC(ServicePath.ROLE_DELETE, data);
     }
 
     static listRoleById(data) {
         return this.postSEC(ServicePath.USER_FIND, data);
     }
     static getRol(data) {
         return this.postSEC(ServicePath.ROLE_GET, data);
     }
 
 }